module.exports = __webpack_public_path__ + "media/img/help_center/Student_Scholarship_Search_08-bc2f66966aa38a672136056d509330b4.jpg";